import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import {FormArray, FormGroup} from "@angular/forms";
import {
  BalanceItem, BokkzJrLogic,
  ClientEntity, FormattedExplanation, Jaarrapportage,
  JaarrapportageEntity, Jaarrekening, TrialBalanceItem
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { combineLatest, distinctUntilChanged, Observable, ReplaySubject, Subject, takeUntil } from 'rxjs';
import { SpecTrialbalanceComponent } from '../spec-trialbalance/spec-trialbalance.component';
import { SpecFormattedexplanationComponent } from '../spec-formattedexplanation/spec-formattedexplanation.component';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-vrijval-uit-herwaarderingsreserve',
  templateUrl: './spec-vrijval-uit-herwaarderingsreserve.component.html',
  imports: [
    SharedUiFormControlsModule,
    SpecTrialbalanceComponent,
    SpecFormattedexplanationComponent,
    SharedUiDetailsModule,
    SharedUiButtonModule,
    CommonModule
  ],
  styleUrls: ['./spec-vrijval-uit-herwaarderingsreserve.component.css']
})
export class SpecVrijvalUitHerwaarderingsreserveComponent implements OnInit,OnChanges,OnDestroy {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private selectedTabSubject = new ReplaySubject<number>(1);
  showCustomControls = true;
  private destroy$ = new Subject<void>();
  public selectedTab = 0;
  public index = 0;
  public dialogVisible = false;
  public client = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public revaluationReserveReleaseFg = {} as FormGroup;
  public revaluationReserveReleaseDisclosureFg = {} as FormGroup;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  constructor(
    public algDataService: BokkzAlgDataService,
    private cdRef: ChangeDetectorRef,
    private jrLogicService: BokkzJrLogic,
    public jrDataService: BokkzJrDataService) {
    this.createFormGroups();
  }

  ngOnInit(): void {
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
        });
    }

    combineLatest([
      this.selectedTabSubject.pipe(distinctUntilChanged()),
      this.jrDataService.jaarrapportageEntity
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([tab, jrEntity]) => {
        this.selectedTab = tab;
        this.jrEntity = jrEntity;
        this.patchData(jrEntity);
      });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTabObservable']) {
      this.selectedTabObservable = changes['selectedTabObservable'].currentValue;
    }
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public createFormGroups() {
    this.revaluationReserveReleaseFg = this.jrDataService.createFormGroupBalanceItem();
    this.revaluationReserveReleaseDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
  }

  private patchData(value: JaarrapportageEntity) {
    const item = value.rapportage?.jaarrekeningen?.at(0)?.winstEnVerliesrekening?.uitHerwaarderingsreserveVrijgevallenBedragen;
    const text = value.rapportage?.jaarrekeningen?.at(0)?.winstEnVerliesrekening?.uitHerwaarderingsreserveVrijgevallenBedragen?.uitHerwaarderingsreserveVrijgevallenBedragenTekstueel;
    if (item) {
      if (item.revaluationReserveRelease) {
        const subItem = item.revaluationReserveRelease;
        this.revaluationReserveReleaseFg.patchValue(subItem)
        this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.revaluationReserveReleaseFg.get('trialBalanceItems') as FormArray)
      }
    }
    if (text) {
      if (text.revaluationReserveReleaseDisclosure) {
        this.revaluationReserveReleaseDisclosureFg.patchValue(text.revaluationReserveReleaseDisclosure);
      }
    }
  }

  updateTrialBalanceItems(lijst?: TrialBalanceItem[], formArray?: FormArray) {
    if (lijst && formArray) {
      for (let i = 0; i < lijst.length; i++) {
        if (i < formArray.length) {
          const control = formArray.at(i) as FormGroup;
          control.patchValue(lijst[i], {emitEvent: false});
        } else {
          const formGroup = this.jrDataService.createFormGroupTrialBalanceItem(lijst[i])
          formArray.push(formGroup, {emitEvent: false});
        }
      }
    }
  }

  saveForm(): void {
    this.showCustomControls = false;
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.showCustomControls = true;
      this.cdRef.detectChanges();
    });
    this.revaluationReserveReleaseFg.updateValueAndValidity({ emitEvent: false });
    this.revaluationReserveReleaseDisclosureFg.updateValueAndValidity({ emitEvent: false });

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        winstEnVerliesrekening: {
          ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening,
          uitHerwaarderingsreserveVrijgevallenBedragen: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.uitHerwaarderingsreserveVrijgevallenBedragen,
            revaluationReserveRelease: this.revaluationReserveReleaseFg.value,
            uitHerwaarderingsreserveVrijgevallenBedragenTekstueel: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.uitHerwaarderingsreserveVrijgevallenBedragen?.uitHerwaarderingsreserveVrijgevallenBedragenTekstueel,
              revaluationReserveReleaseDisclosure: this.revaluationReserveReleaseDisclosureFg.value,
            }
          }
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrLogicService.getCalculation(this.jrEntity)
    this.jrDataService.updateEntity(this.jrEntity);
  }

}
